import axios from 'axios';


const API_HOST_URL = 'https://services.rappi.com'
const API_PREFIX_PATH = API_HOST_URL + '/core-home-proxy/cauth/home-auth'

const UsersApi = {

  getUsers: async (token) => {
    try {
        const response = await axios.get(API_PREFIX_PATH + '/user', {
            headers: { Authorization: `Bearer ${token}` },
        });

      return response.data.users;
    } catch (error) {
      console.error(error);
      throw error;
    }
  },

  createUser: async (email, token) => {
    try {
        const body = { "email": email, "roles": [ "USER" ] }
        const response = await axios.post(API_PREFIX_PATH + '/user', body, {
            headers: { Authorization: `Bearer ${token}` },
        });

      return response.data
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};

export default UsersApi;
